import React from "react";
import { useState } from "react";
import "../../style/portfolio.css";
import restaurantDesktop from "../../images/restaurantDesktop.jpg";
import restaurantMobile from "../../images/restaurantMobile.jpg";

const Restaurant = () => {
  const [desktop, setDesktop] = useState(true);
  const desktopImg = () => {
    setDesktop(true);
  };
  const mobileImg = () => {
    setDesktop(false);
  };

  return (
    <div className="portfolio-element">
      <div className="portfolio-right">
        <h1 className="headings-portfolio">Restaurante/E-commerce</h1>
        <p>
          Este proyecto puso a prueba mis habilidades por la codificación del
          diseño, especialmente al colocar los patrones de fondo para los
          diferentes tamaños de pantalla. Usé una combinación de CSS flexbox y
          grid para el diseño receptivo de las secciones de contenido principal
          de la página. Otra de las funciones de la página, es que el usuario
          puede logear y realizar el seguimiento de sus pedidos.
        </p>
        <a target="blank" href="https://restaurante-banderas-app.netlify.app/">
          <button className="btn-visitar">Ver proyecto</button>
        </a>
        <a
          target="blank"
          href="https://github.com/khanchandanivikas/restaurante-frontend"
        >
          <button className="btn-visitar">Ver codigo</button>
        </a>
      </div>
      <div className="portfolio-left">
        <img
          src={desktop ? restaurantDesktop : restaurantMobile}
          alt="weather app"
        />
        <br />
        <button
          className={desktop ? "btn-active" : "btn-inactive"}
          onClick={desktopImg}
        >
          DISEÑO DESKTOP
        </button>
        <button
          className={desktop ? "btn-inactive" : "btn-active"}
          onClick={mobileImg}
        >
          DISEÑO MOVIL
        </button>
      </div>
    </div>
  );
};

export default Restaurant;
